import React from "react";
import {
  Grid,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  IconButton,
  Dialog,
} from "@mui/material";
import "react-quill/dist/quill.snow.css";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../../globalStyles/fonts";

const PackageDetailsModal = ({ weight, open, onClose }) => {
  const clientId = localStorage.getItem("client_id");
  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <DialogTitle
            fontSize={"20px"}
            fontFamily={"poppins"}
            fontWeight={500}
            color={"var(--text-tertiary)"}
          >
            {"Package Type Details"}
          </DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <Divider style={{ marginBottom: "10px" }} />
        <DialogContent>
          <Grid container spacing={2}>
            {/* {!clientId ? (
              <Grid item xs={12} md={12}>
                <CustomTypography>Client</CustomTypography>
                <TextField
                  size="small"
                  autoFocus
                  margin="dense"
                  variant="outlined"
                  type="text"
                  fullWidth
                  value={weight?.client_id?.business_name || ""}
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={{
                    "& .MuiInputBase-input": {
                      color: "var(--text-secondary)",
                    },
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "var(--bg-input)",
                    },
                  }}
                />
              </Grid>
            ) : (
              <></>
            )} */}
            <Grid item xs={12} sm={6}>
              <CustomTypography fontSize={15}>Name</CustomTypography>
              <TextField
                size="small"
                variant="outlined"
                value={weight?.name}
                fullWidth
                autoFocus
                margin="dense"
                InputProps={{
                  readOnly: true,
                  style: { color: "var(--text-secondary)", backgroundColor: "var(--bg-input)" },
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    color: "var(--text-secondary)",
                  },
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography fontSize={15}>Type</CustomTypography>
              <TextField
                size="small"
                variant="outlined"
                value={weight?.type}
                fullWidth
                autoFocus
                margin="dense"
                InputProps={{
                  readOnly: true,
                  style: { color: "var(--text-secondary)", backgroundColor: "var(--bg-input)" },
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    color: "var(--text-secondary)",
                  },
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography fontSize={15}>Warehouse</CustomTypography>
              <TextField
                size="small"
                variant="outlined"
                value={weight?.warehouse?.provider?.name || weight?.warehouse.name}
                fullWidth
                autoFocus
                margin="dense"
                InputProps={{
                  readOnly: true,
                  style: { color: "var(--text-secondary)", backgroundColor: "var(--bg-input)" },
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    color: "var(--text-secondary)",
                  },
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTypography fontSize={15}>Weight</CustomTypography>
              <TextField
                sx={{
                  "& .MuiInputBase-input": {
                    color: "var(--text-secondary)",
                  },
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "var(--bg-input)",
                  },
                }}
                type="email"
                size="small"
                variant="outlined"
                value={`${weight?.min_weight}/${weight?.min_weight_unit} - ${weight?.max_weight}/${weight?.max_weight_unit}`}
                fullWidth
                autoFocus
                margin="dense"
                InputProps={{
                  readOnly: true,
                  style: { color: "var(--text-secondary)", backgroundColor: "var(--bg-input)" },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography fontSize={15}>Dimension</CustomTypography>
              <TextField
                sx={{
                  "& .MuiInputBase-input": {
                    color: "var(--text-secondary)",
                  },
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "var(--bg-input)",
                  },
                }}
                type="email"
                size="small"
                variant="outlined"
                value={`${weight?.dimension.length} * ${weight?.dimension.width} * ${weight?.dimension.height} (${weight?.dimension.height_unit})`}
                autoFocus
                margin="dense"
                InputProps={{
                  readOnly: true,
                  style: { color: "var(--text-secondary)", backgroundColor: "var(--bg-input)" },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography fontSize={15}>Package Weight</CustomTypography>
              <TextField
                sx={{
                  "& .MuiInputBase-input": {
                    color: "var(--text-secondary)",
                  },
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "var(--bg-input)",
                  },
                }}
                type="email"
                size="small"
                variant="outlined"
                value={`${weight?.pkg_weight} ${weight?.pkg_weight_unit}`}
                fullWidth
                autoFocus
                margin="dense"
                InputProps={{
                  readOnly: true,
                  style: { color: "var(--text-secondary)", backgroundColor: "var(--bg-input)" },
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: 10 }}>
          <Button
            onClick={onClose}
            variant="outlined"
            style={{ textTransform: "none" }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default PackageDetailsModal;
